import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'

// 📦 Vistas de Cajas
const GestionCajasApp = Loadable(lazy(() => import('./view/gestionCajas')))

// 🌟 Wrapper que pasa automáticamente el usuario al provider
import { Loadable } from '../base/components/Lodable'

// 🗺️ Mapa de rutas para Cajas
export const cajasRoutesMap = {
  gestion: { path: '/cajas/gestion', name: 'Gestión de Cajas' },
  arqueo: { path: '/cajas/arqueo', name: 'Arqueo y Cierre' },
  retiros: { path: '/cajas/retiros', name: 'Retiros' },
}

// 📌 Definición de rutas
const cajasRoutes = [
  {
    path: cajasRoutesMap.gestion.path,
    element: <GestionCajasApp />,
    auth: authRoles.admin,
  },
]

export default cajasRoutes
